"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propAccessor = void 0;
const ramda_1 = require("ramda");
/**
 * Retrieves the value of an object property. This could look for nesded properties providing a dot notation query.
 * @public
 *
 * @param objectToBeChecked - object to access
 * @param path - string or array with dot notation path
 * @param defaultValue - optional parameter for default if the full key in path is missing
 *
 * @returns The value that corresponds to the key provided or a default value.
 *
 * @example
 * ```ts
 * const config = {
 *   key: 'value',
 * }
 * const result = propAccessor(config, 'key')
 * // -> result === 'value'
 * ```
 */
function propAccessor(objectToBeChecked, path, defaultValue) {
    return (0, ramda_1.defaultTo)(defaultValue)((0, ramda_1.path)(typeof path === 'string' ? path.split('.') : path, objectToBeChecked));
}
exports.propAccessor = propAccessor;
//# sourceMappingURL=prop-accessor.js.map